import axios from "axios";
import React, { Component } from "react"; 
import { Loader } from "../../../common/loader/loader.jsx";
import ListOfArticlesJsx from "./listOfArticles.jsx"
import {baseURL} from "../../../../constants/applicationConstants"

export default class ListOfArticles extends Component {
  constructor(props){
    super(props);
    this.state={
      articleData:null,
      page:1,
      profileData:null,
    }
  }

  componentDidMount = () =>{ 
    if (this.props.location?.state?.data) {
      const { data } = this.props.location?.state; 
      data && this.setState({profileData:data}, () => this.getArticlesData());
    }
    // this.getArticlesData();
  }

  getArticlesData = () => {
    const token = JSON.parse(localStorage.getItem('token'));

    this.setState({ isProcessing: true })


    axios.get(`${baseURL}/articles?page=${this.state.page}&expertid=${ this.state?.profileData?.instituteId}&limit=-1`,
        {
          headers: { 'x-access-token': token }
        }).then(res => {
          
            this.setState({ articleData: res.data.data, isProcessing: false });
        }).catch(err => {
            this.setState({ isProcessing: false })
        })
        
}

onPaginationButtonClick = (page) => {
  window.scrollTo(0, 0);
  this.setState({ page: page })
}

  
 

    render() {
      return (
        <div>
          <ListOfArticlesJsx 
          articleData={this.state.articleData}
          onPaginationButtonClick={this.onPaginationButtonClick}
          page={this.state.page}
          profileData={this.state.profileData}
          />
          {this.state.isProcessing && <Loader />}
        </div>
      );
    }
  }
  
 